import { Timestamp } from "firebase/firestore";

interface DateObject {
  day: {
    number: string;
    name: string;
  };
  month: {
    number: string;
    name: string;
  };
  year: {
    short: string;
    long: string;
  };
  full: string;
  short: string;
}

export function ParseDay(day: number) {
  switch (day) {
    case 1:
      return "Mån";
    case 2:
      return "Tis";
    case 3:
      return "Ons";
    case 4:
      return "Tors";
    case 5:
      return "Fre";
    case 6:
      return "Lör";
    default:
      return "Sön";
  }
}

function parseMonth(month: number) {
  switch (month) {
    case 1:
      return "feb";
    case 2:
      return "mar";
    case 3:
      return "apr";
    case 4:
      return "maj";
    case 5:
      return "jun";
    case 6:
      return "jul";
    case 7:
      return "aug";
    case 8:
      return "sep";
    case 9:
      return "okt";
    case 10:
      return "nov";
    case 11:
      return "dec";
    default:
      return "jan";
  }
}

export function GetDisplayDate(date: Date, shortFormat?: boolean) {
  if (date.getMonth() === new Date().getMonth()) {
    if (date.getDate() === new Date().getDate()) return "IDAG";
    if (date.getDate() === new Date().getDate() + 1) return "IMORGON";
  }
  return shortFormat
    ? `${ParseDay(date.getDay())} ${date.getDate()} ${parseMonth(
        date.getMonth()
      )}`
    : `${ParseDay(date.getDay())} ${date.getDate()} ${parseMonth(
        date.getMonth()
      ).toUpperCase()} ${date.getFullYear()}`;
}

export function FormatDate(date: Date) {
  const y = date.getFullYear();
  const m =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const d = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

  return `${y}-${m}-${d}`;
}

export function FormatSwedishShortDate(sweShortDate: string) {
  const today = new Date();
  const y = today.getFullYear();
  let m, d;
  if (sweShortDate === "Idag") {
    m = today.getMonth() < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
    d = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  } else if (sweShortDate === "Imorgon") {
    const tomorrow = new Date(today)
    tomorrow.setDate(tomorrow.getDate() + 1)
    m = tomorrow.getMonth() < 10 ? `0${tomorrow.getMonth() + 1}` : tomorrow.getMonth() + 1;
    d = tomorrow.getDate() < 10 ? `0${tomorrow.getDate()}` : tomorrow.getDate();
  } else {
    m = parseInt(sweShortDate.substring(sweShortDate.indexOf('/') + 1))
    m = m < 10 ? `0${m}` : m
    d = parseInt(sweShortDate.substring(sweShortDate.indexOf(' ') + 1, sweShortDate.indexOf('/')))
    d = d < 10 ? `0${d}` : d
  }

  return `${y}-${m}-${d}`;
}

export function GetTimeSpan(startTime: Timestamp, endTime: Timestamp) {
  let s = GetTimeFromDate(startTime.toDate());
  const e = GetTimeFromDate(endTime.toDate());
  const startSplit = s.split(":");
  const endSplit = e.split(":");
  const zero = "0";

  if (startSplit[0].length === 1) startSplit[0] = zero.concat(startSplit[0]);
  if (startSplit[1].length === 1) startSplit[1] = zero.concat(startSplit[1]);
  if (endSplit[0].length === 1) endSplit[0] = zero.concat(endSplit[0]);
  if (endSplit[1].length === 1) endSplit[1] = zero.concat(endSplit[1]);

  return `${startSplit[0]}:${startSplit[1]}-${endSplit[0]}:${endSplit[1]}`;
}

export function GetTimeFromDate(date: Date) {
  return `${date.getHours()}:${date.getMinutes()}`;
}

export function HasWorkoutFinished(endDate: Date) {
  return new Date() >= endDate
}

export function IsWorkoutInProgress(startDate: Date, endDate: Date) {
  const now = new Date()
  return now <= endDate && now >=startDate
}

/**
 * Creates a date object
 *
 * @example
 * ```javascript
 *
 * // Initialize default app
 * // Retrieve your own options values by adding a web app on
 * // https://console.firebase.google.com
 * initializeApp({
 *   apiKey: "AIza....",                             // Auth / General Use
 *   authDomain: "YOUR_APP.firebaseapp.com",         // Auth with popup/redirect
 *   databaseURL: "https://YOUR_APP.firebaseio.com", // Realtime Database
 *   storageBucket: "YOUR_APP.appspot.com",          // Storage
 *   messagingSenderId: "123456789"                  // Cloud Messaging
 * });
 * ```
 * ```
 *
 * @param options - Options to configure the app's services.
 * @param name - Optional name of the app to initialize. If no name
 *   is provided, the default is `"[DEFAULT]"`.
 *
 * @returns The initialized app.
 *
 * @public
 */
export default function useTimestamp(timestamp: Timestamp): DateObject {
  const tsDate = timestamp.toDate();

  const y = tsDate.getFullYear();
  const m =
    tsDate.getMonth() < 10
      ? `0${tsDate.getMonth() + 1}`
      : tsDate.getMonth() + 1;
  const d = tsDate.getDate() < 10 ? `0${tsDate.getDate()}` : tsDate.getDate();

  return {
    day: {
      number: tsDate.getDate().toString(),
      name: ParseDay(tsDate.getDay()),
    },
    month: {
      number: (tsDate.getMonth() + 1).toString(),
      name: parseMonth(tsDate.getMonth()),
    },
    year: {
      short: tsDate.getFullYear().toString().slice(2),
      long: tsDate.getFullYear().toString(),
    },
    full: `${y}-${m}-${d}`,
    short: `${tsDate.getDate().toString()}/${tsDate.getMonth() + 1} -${tsDate
      .getFullYear()
      .toString()
      .slice(2)}`,
  };
}
